import {omit} from "@pg-mono/nodash";
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {IFetchParams} from "../utils/get_property_api_params";

export type IAllPropertiesCountBudgetResponse = {
    price_range: {
        lower: number;
        upper: number;
    };
    property_count: number;
}[];

export const fetchAllPropertiesCountBudget = (params: IFetchParams) => {
    const url = appendQueryString(apiV2Link.property.budget(null), {
        ...omit({...params}, ["price_0", "price_1"]),
        page_size: 0
    });

    return getRequest({}, url).then((json: IAllPropertiesCountBudgetResponse) => {
        return json;
    });
};
import {omit} from "@pg-mono/nodash";
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {IFetchParams} from "../utils/get_property_api_params";

export type IAllPropertiesCountBudgetResponse = {
    price_range: {
        lower: number;
        upper: number;
    };
    property_count: number;
}[];

export const fetchAllPropertiesCountBudget = (params: IFetchParams) => {
    const url = appendQueryString(apiV2Link.property.budget(null), {
        ...omit({...params}, ["price_0", "price_1"]),
        page_size: 0
    });

    return getRequest({}, url).then((json: IAllPropertiesCountBudgetResponse) => {
        return json;
    });
};
